/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Pay/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ChooseType from './ChooseType/index'
import PayAction from './PayAction/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Pay({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/AutopaymentSetup/Pay"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Pay.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-luB': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Pay.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 marginBottom={dtSpaceS}
 text="Setup your autopay source"
/>
<ChooseType
  viewPath={`${viewPath}/ChooseType`}
/>
</div>
<div
  data-testid="Pay.Vertical:2"
  data-view-path={viewPath}
 borderTopRadius={1}
 style={{'--btc-2-luB': dtColorsNeutral200,'--pt-3-luB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-4-luB': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical1}`}
>
<PayAction
  viewPath={`${viewPath}/PayAction`}
/>
</div>
</div>
{children}
</React.Fragment>)
}